import ContatoWhatsApp from "@/components/ContatoWhatsApp";
import Logo from "@/components/Logo";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import BotaoPrincipal from "../../../../components/BotaoPrincipal";
import { ehHomologacao, ehProducao } from "../../../../services/ambiente";

export default function ApiDocsV1() {
  const abrirDocumentacao = () => {
    if (ehProducao()) {
      window.open("https://api.quitapay.com/api-docs/v1", "_blank");
    } else if (ehHomologacao()) {
      window.open("https://api.homologacao.quitapay.com/api-docs/v1", "_blank");
    } else {
      window.open("http://localhost:21092/api-docs/v1", "_blank");
    }
  };
  return (
    <Container component="main" maxWidth="lg" sx={{ mb: 4 }}>
      <Paper
        variant="outlined"
        sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
        <Grid container sx={{ marginBottom: "1rem" }}>
          <Grid
            item
            size={12}
            sx={{ display: "flex", justifyContent: "center" }}>
            <Logo></Logo>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid
            item
            size={12}
            sx={{ display: "flex", justifyContent: "center" }}>
            <Typography variant="h3">
              Manual de integração de API QuitaPay
            </Typography>
          </Grid>
          <Grid
            item
            size={12}
            sx={{ display: "flex", justifyContent: "center" }}>
            <BotaoPrincipal
              type="button"
              onClick={() => {
                abrirDocumentacao();
              }}>
              DOCUMENTAÇÃO DA API
            </BotaoPrincipal>
          </Grid>
          <Grid item size={12}>
            <Typography>
              Encontre aqui a documentação para integração da API QuitaPay. Na
              integração é possível realizar diversas operações como consulta e
              inclusão de pedidos, simulações, consulta de comissões, etc.
            </Typography>
          </Grid>
          <Grid
            item
            size={12}
            sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Typography variant="h4">Passos para a integração</Typography>
          </Grid>
          <Grid item size={12}>
            <Typography>
              O primeiro passo é realizar o envio da operação com os dados
              completos do cliente.
            </Typography>

            <Typography>
              Em caso de sucesso, a resposta irá conter o link para checkout no
              atributo "paymentLink" onde deverá ser aberto pelo cliente para
              informar os dados do cartão de crédito e realizar o pagamento da
              operação.
            </Typography>

            <Typography>
              Se a transação for autorizada o cliente será direcionado para
              realizar a assinatura do contrato.
            </Typography>

            <Typography>
              Caso o cliente não conclua a assinatura do contrato, você deverá
              consultar a operação e direcionar o cliente para o link disponível
              no atributo "paymentLink".
            </Typography>

            <Typography>
              Para finalizar a operação é obrigatório realizar todas as etapas
              solicitadas.
            </Typography>

            <Typography>
              Após todos os passos serem realizados, a operação passará pela
              análise de segurança e em até 48 horas úteis o boleto ou PIX
              informado será quitado.
            </Typography>
          </Grid>
          <Grid
            item
            size={12}
            sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Typography variant="h4">
              Ambiente de homologação e produção
            </Typography>
          </Grid>
          <Grid item size={12}>
            <Typography variant="h6">Homologação:</Typography>
            <Typography>https://api.homologacao.quitapay.com/</Typography>
          </Grid>
          <Grid item size={12}>
            <Typography variant="h6">Produção</Typography>
            <Typography>https://api.quitapay.com</Typography>
          </Grid>
          <Grid
            item
            size={12}
            sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Typography variant="h4">
              Cadastro e credenciais de acesso
            </Typography>
          </Grid>
          <Grid item size={12}>
            <Typography>
              Acesse https://quitapay.com para realizar seu cadastro em
              produção.
            </Typography>

            <Typography>
              Para utilizar o ambiente de homologação realize seu cadastro em
              https://app.homologacao.quitapay.com/parceiro/cadastro
            </Typography>

            <Typography>
              Lembre-se, como são ambientes diferentes os dados de acesso também
              podem ser diferentes.
            </Typography>
          </Grid>
          <Grid
            item
            size={12}
            sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Typography variant="h4">Autenticação</Typography>
          </Grid>
          <Grid item size={12}>
            <Typography>
              Você deve fornecer sua API KEY no header "api_key" em todas as
              requisições.{" "}
            </Typography>
            <Typography>
              Para obter sua API KEY acesse a sessão "DESENVOLVEDORES" no menu
              "CONFIGURAÇÕES" da área do parceiro.
            </Typography>
          </Grid>
          <Grid
            item
            size={12}
            sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Typography variant="h4">Status das operações</Typography>
          </Grid>
          <Grid item size={12}>
            <Typography variant="h6">
              Os possíveis status das operações são os seguintes:
            </Typography>
            <Typography>
              {" "}
              - pending - Aguardando pagamento do cliente
            </Typography>
            <Typography>
              {" "}
              - confirmed - Transação do cliente autorizada
            </Typography>
            <Typography>
              - finished - Operação finalizada (Débitos quitados)
            </Typography>
            <Typography> - refunded - Estornado</Typography>
            <Typography> - error - Transação não autorizada</Typography>
            <Typography> - chargeback - Chargeback</Typography>
            <Typography variant="h6" sx={{ mt: 1 }}>
              A etapa atual detalhada pode ser verificada no campo
              "validationStep" com os seguintes valores:
            </Typography>
            <Typography>
              - payment-pending - Aguardando transação do cliente (Status
              "pending")
            </Typography>
            <Typography>
              - payment-error - Transação não autorizada (Status "error")
            </Typography>
            <Typography> - refunded - Estornado (Status "refunded")</Typography>
            <Typography>
              - pending-register-confirmation - Aguardando confirmação do
              cliente (contrato) (Status "confirmed")
            </Typography>
            <Typography>
              - waiting-antifraud - Aguardando execução da verificação
              anti-fraude (Status "confirmed")
            </Typography>
            <Typography>
              - waiting-finalization - Validação anti-fraude concluída e em fila
              para pagamento dos débitos (Status "confirmed")
            </Typography>
            <Typography>
              - finished - Operação finalizada (Débitos quitados) (Status
              "finished")
            </Typography>
          </Grid>
          <Grid
            item
            size={12}
            sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Typography variant="h4">Webhook</Typography>
          </Grid>
          <Grid item size={12}>
            <Typography>
              O Webhook pode ser ativado informando as URL's de destino de cada
              etapa no menu "Configurações > Webhook" da área do parceiro.{" "}
            </Typography>
            <Typography>
              Também é possível informar uma URL personalizada para cada
              operação no atributo "callbackUrl" da API.{" "}
            </Typography>
            <Typography>
              Após o preenchimento ou alteração de status de cada operação, será
              efetuado o disparo com o seguinte payload:
            </Typography>
          </Grid>
          <Grid item size={12}>
            <code>
              {`{    id: "ID da operação",
                  status: "Status da operação (pending, confirmed, finished, refunded, chargeback ou error)",
                  validationStep: "Etapa da operação (waiting-antifraud, waiting-finalization, finished, etc)",
                  externalRef : "idExternoExemplo",
                  externalExtraData : "Outros dados do parceiro informados na API",
                  type: "Origem do webhook (requests)"
              }`}
            </code>
          </Grid>
          <Grid
            item
            size={12}
            sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Typography variant="h4">Cenários teste (Homologação)</Typography>
          </Grid>
          <Grid item size={12}>
            <Typography>
              No ambiente de homologação, você pode utilizar os seguintes
              números de cartões para testar os status das operações:
            </Typography>
            <Typography>
              - Cartões iniciados com 1, 2, 3, 4, 5, 6, 7 ou 8 - Transação
              autorizado (status "confirmed", validationStep
              "pending-register-confirmation")
            </Typography>
            <Typography>
              - Cartões iniciados com 22 - Transação autorizada e contrato
              assinado e aguardando anti fraude (status "confirmed",
              validationStep "waiting-antifraud")
            </Typography>
            <Typography>
              - Cartões iniciados com 33 - Transação autorizada e operação
              marcada como pendente de finalização (status "confirmed",
              validationStep "waiting-finalization").
            </Typography>
            <Typography>
              - Cartões iniciados com 44 - Transação autorizada e operação
              finalizada em seguida (status "finished", validationStep
              "finished").
            </Typography>
            <Typography>
              - Cartões iniciados com 88 - Transação autorizada por sucesso
              porém será estornada em seguida (status "refunded", validationStep
              "refunded").
            </Typography>
            <Typography>
              - Cartões iniciados com 91 - Transação não autorizada por cartão
              não possuir limite (status "error", validationStep
              "payment-error")
            </Typography>
            <Typography>
              - Outros cartões iniciados com 9 - Transação não autorizada por um
              erro geral ao processar o pagamento (status "error",
              validationStep "payment-error")
            </Typography>
            <Typography>
              - Outros números não mapeados acima autorizam a cobrança com
              sucesso (status "confirmed", validationStep
              "pending-register-confirmation")
            </Typography>
            <Typography>
              - As operações em ambiente de homologação que estão aberto (status
              "confirmed") serão estornadas automaticamente após 24 horas da
              inclusão.
            </Typography>
          </Grid>
          <Grid
            item
            size={12}
            sx={{ display: "flex", justifyContent: "center" }}>
            <BotaoPrincipal
              type="button"
              onClick={() => {
                abrirDocumentacao();
              }}>
              DOCUMENTAÇÃO DA API
            </BotaoPrincipal>
          </Grid>
        </Grid>
      </Paper>
      <ContatoWhatsApp></ContatoWhatsApp>
    </Container>
  );
}
